export function delay(milliseconds: number): Promise<any> {
  return new Promise((resolve) =>
    setTimeout(() => {
      resolve(undefined);
    }, milliseconds),
  );
}
